import { DrawerClose, DrawerContent } from '@/modules/components/ui/drawer'
import { X } from 'lucide-react'
import Link from 'next/link'
import React from 'react'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { Button } from '~shared/components/button-v2'
import { LogoBurger } from '~shared/components/logo-burger'
import { Hit } from '~shared/icons/hit'
import { TelegramIcon } from '~shared/icons/telegram'
import { VkIcon } from '~shared/icons/vk'
import { cn } from '~shared/utils/cn'
import { LeadFormDialog } from '~widgets/lead-form/components/lead-form-dialog'

type BurgerMenuProps = {
  categories: Awaited<ReturnType<typeof getCategoriesData>>
}

export const BurgerMenuDrawer: React.FC<BurgerMenuProps> = ({ categories }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <DrawerContent className='container w-[264px] right-[10px] top-[16px]'>
      <div
        className='rounded-[22px] bg-white p-[16px] flex flex-col h-[calc(100dvh-32px)] box-border max-h-[650px]
    '>
        <div className='flex items-center justify-between'>
          <LogoBurger />
          <span className='cursor-pointer w-[30px] h-[30px] rounded-full bg-[#F2F2F2] flex items-center justify-center'>
            <DrawerClose asChild>
              <X className='max-h-[17px] max-w-[17px]' />
            </DrawerClose>
          </span>
        </div>
        <ul className='flex flex-col font-medium max-h-[300px] justify-between h-full mt-[30px] mb-[20px]'>
          {categories &&
            categories?.categories?.map(el => (
              <li
                key={el.name}
                className='hover:underline flex items-center gap-[8px]'>
                <Link
                  prefetch={false}
                  href={
                    [
                      'bakalavriat',
                      'magistratura',
                      'kursy',
                      'college'
                    ].includes(el?.slug ?? '')
                      ? `/programs/${el?.slug}`
                      : `/${el.slug}`
                  }>
                  {el.name}
                </Link>
                {el?.discount && (
                  <span
                    className={cn(
                      'bg-[#FE634E] w-[125px]  text-white rounded-[24px] h-[30px] text-[12px] font-normal',
                      'gap-[4px] flex items-center justify-center'
                    )}>
                    <Hit size={13} className='inline-block' color='white' />
                    Скидки до {el?.discount}%
                  </span>
                )}
              </li>
            ))}
          <li className='text-[#3A52EE] hover:underline'>
            <Link href='/journal'>Журнал</Link>
          </li>
          <li className='text-[#3A52EE] hover:underline'>
            <Link href='/contact'>Контакты</Link>
          </li>
        </ul>
        <div className='h-12 items-center flex gap-[40px] text-black mt-auto '>
          <Link href='https://t.me/mitm_institute'>
            <TelegramIcon className='size-6' />
          </Link>
          <Link href='https://vk.com/mitm.institute'>
            <VkIcon className='size-6' />
          </Link>
        </div>
        <div className='flex flex-col gap-[20px]'>
          <a href='tel:+7(800)333-71-38'>
            <p className='text-[10px] text-[#8B8B8B] mb-[8px]'>
              Бесплатно по России
            </p>
            <p className='text-[14px] font-medium'>+7 (800) 444-81-38</p>
          </a>
          <a href='tel:+7(495)648-62-23'>
            <p className='text-[10px] text-[#8B8B8B] mb-[8px]'>
              Бесплатно по Москве
            </p>
            <p className='text-[14px] font-medium'>+7(495)648-62-23</p>
          </a>
        </div>
        <Button
          variant='primary'
          className='w-full min-h-[55px] mt-[20px]'
          onClick={() => setIsOpen(true)}>
          Записаться на курс
        </Button>
        <LeadFormDialog open={isOpen} onOpenChange={setIsOpen} />
      </div>
    </DrawerContent>
  )
}
